export default __webpack_public_path__ + "static/inventory-optimisation-2-3b9a1603c95669dbc57c155efc8becbc.png";